import script from "./CartPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPopover.vue?vue&type=script&setup=true&lang=js"

import "./CartPopover.vue?vue&type=style&index=0&id=4bf00758&scoped=true&lang=css"
import "./CartPopover.vue?vue&type=style&index=1&id=4bf00758&lang=css"

import exportComponent from "C:\\Users\\User\\Downloads\\ASKNC-Website\\asknc-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf00758"]])

export default __exports__